module.exports = __webpack_public_path__ + "img/75-1.ab96322d.svg";